import { useCountFrequentlyBought, useCountWishlist, useSumCartQuantity } from '@/apis/rest/generated/hooks'
import { useCustomRouter } from '@/containers/hooks'
import { UserContainer } from '@/containers/users/UserContainer'

export const useCartContainer = () => {
  const { pathname } = useCustomRouter()
  const { me } = UserContainer.useContainer()

  const isCartPage = pathname === '/cart'

  const { data: cartCountData } = useSumCartQuantity({
    query: {
      enabled: isCartPage && !!me,
      keepPreviousData: true,
    },
  })

  const { data: likeCountData, isLoading: isLikeCountLoading } = useCountWishlist({
    query: {
      enabled: isCartPage && !!me,
    },
  })
  const { data: frequentlyCountData, isLoading: isFrequentlyCountLoading } = useCountFrequentlyBought({
    query: {
      enabled: isCartPage && !!me,
    },
  })

  const cartCount = me ? cartCountData?.count || 0 : 0
  const likeCount = me ? likeCountData?.count || 0 : 0
  const frequentlyCount = me ? frequentlyCountData?.count || 0 : 0

  const isAllTabCountLoading = isLikeCountLoading || isFrequentlyCountLoading

  return {
    cartCount,
    likeCount,
    frequentlyCount,
    isAllTabCountLoading,
  }
}
